import React from 'react';
import { Button, Form, Input, Label, Icon, FormField, Radio } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { LibraryControlComponent } from '../../views/control_library/control_library_components';
import { getText } from '../../helpers'

function LibraryControlAsOption(props) {
  const { selectedLibraryControls, setAsSelectedControl, libraryControl } = props;
  const selectedClass = selectedLibraryControls.some(({ id }) => id === libraryControl.id) ? 'selected-control' : '';
  
  return (
    <div
      key={"control-" + libraryControl.id }
      className={'control-details library-control-details ' + selectedClass}
      onClick={()=>setAsSelectedControl(libraryControl)}
    >
      <LibraryControlComponent control={libraryControl} instanceConfig={props.instanceConfig} />
    </div>
  )
}

function LibraryControlsList(props) {
  return (
    <InfiniteScroll
      className="library-controls-list"
      dataLength={props.libraryControls.length}
      next={props.getMoreLibraryControls}
      hasMore={true}
      height={1}
    >
      <div className="library-controls-options">
        {
          props.libraryControls.map((libraryControl) => {
            return <LibraryControlAsOption
                      key={libraryControl.custom_id}
                      libraryControl={libraryControl}
                      selectedLibraryControls={props.selectedLibraryControls}
                      setAsSelectedControl={props.setAsSelectedControl}
                      instanceConfig={props.instanceConfig}
                    />
          })
        }
        {
          props.isfetchingLibraryControls &&
          <div className="loading-message">
            <i className="loading circle notched icon"></i>
            <span>{getText("Fetching library controls")}...</span>
          </div>
        }
        {
          !props.isfetchingLibraryControls && props.libraryControls.length === 0 &&
          <div className="no-result-message">
            <span>{getText("No library control was found.")}</span>
          </div>
        }
      </div>
    </InfiniteScroll>
  )
}

function LibraryControlSelector(props) {
  const showSelectedControls = props.selectedLibraryControls && props.selectedLibraryControls.length > 0;

  return (
    <div className="display-with-caption">
      <div>
        <Input
          className="search-library-control"
          fluid icon='search'
          placeholder={`${getText("Search controls")}...`}
          onChange={props.handleSearchChange}
        />
        {
          showSelectedControls &&
          <div className="selected-library-controls">
            <strong>{getText("Selected Custom Controls")}:</strong>
            {
              props.selectedLibraryControls.map((control) => (
                <Label basic color="purple" size="medium" key={control.custom_id}>
                  <strong>{control.custom_id}</strong>
                  <Icon name='delete' onClick={() => props.setAsSelectedControl(control)}/>
                </Label>
              ))
            }
          </div>
        }
      </div>
      <LibraryControlsList
        libraryControls={props.libraryControls}
        selectedLibraryControls={props.selectedLibraryControls}
        getMoreLibraryControls={props.getMoreLibraryControls}
        setAsSelectedControl={props.setAsSelectedControl}
        instanceConfig={props.instanceConfig}
        isfetchingLibraryControls={props.isfetchingLibraryControls}
      />
    </div>
  )
}

const RiskLevelOptions = (props) => {
  const { value, handleChange, workPhase, activity, hazard, unwantedEvent } = props;
  const workPhaseLabel = (<label>Apply to all risks with Work Phase or Ambient Exposure as <span className='risk-level-option-text'>{workPhase}</span>.</label>);
  const activityLabel = (<label>Apply to all risks with Work Phase or Ambient Exposure as above and Activity as <span className='risk-level-option-text'>{activity}</span>.</label>);
  const hazardLabel = (<label>Apply to all risks with Work Phase or Ambient Exposure | Activity as above and Hazard (Risk Source) as <span className='risk-level-option-text'>{hazard}</span>.</label>);
  const unwantedEventLabel = (<label>Apply to this risk with Work Phase or Ambient Exposure | Activity | Hazard (Risk Source) as above and (Unwanted) Event as <span className='risk-level-option-text'>{unwantedEvent}</span>.</label>)

  return (
    <Form className='risk-level-options'>
      <FormField>
        <label>How would you like this/these control/s to be added to the system?</label>
      </FormField>
      <FormField>
        <Radio
          label={workPhaseLabel}
          name='radioGroup'
          value='work_phase'
          checked={value === 'work_phase'}
          onChange={handleChange}
        />
      </FormField>
      <FormField>
        <Radio
          label={activityLabel}
          name='radioGroup'
          value='activity'
          checked={value === 'activity'}
          onChange={handleChange}
        />
      </FormField>
      <FormField>
        <Radio
          label={hazardLabel}
          name='radioGroup'
          value='hazard'
          checked={value === 'hazard'}
          onChange={handleChange}
        />
      </FormField>
      <FormField>
        <Radio
          label={unwantedEventLabel}
          name='radioGroup'
          value='unwanted_event'
          checked={value === 'unwanted_event'}
          onChange={handleChange}
        />
      </FormField>
    </Form>
  )
}

export function CreateTemplateControlModalContent(props) {
  const { control, instanceConfig, workPhase, activity, hazard, unwantedEvent, handleFilterByRiskLevelChange, filterByRiskLevel, isfetchingLibraryControls,
    isfetchingCustomControls
   } = props;

  return (
    <div className='display-with-caption'>
      <RiskLevelOptions
        value={control.risk_level}
        handleChange={props.handleRiskLevelChange}
        workPhase={workPhase}
        activity={activity}
        hazard={hazard}
        unwantedEvent={unwantedEvent}
      />
      <label>Select the library control/s</label>
      <LibraryControlSelector
        libraryControls={props.libraryControls}
        selectedLibraryControls={props.selectedLibraryControls}
        handleSearchChange={props.handleSearchChange}
        getMoreLibraryControls={props.getMoreLibraryControls}
        setAsSelectedControl={props.setAsSelectedControl}
        instanceConfig={instanceConfig}
        isfetchingLibraryControls={isfetchingLibraryControls}
      />
    </div>
  )
}

export function CreateTemplateControlModalActions(props) {
  const { disableSave, hideCreateControl, onSaveControl } = props;
  return (
    <div className="create-control-buttons">
      <Button size='medium' className="cancel-create-button" onClick={hideCreateControl}>
        {getText("Cancel")}
      </Button>
      <Button positive size='medium' className="save-control-button" onClick={onSaveControl} disabled={disableSave}>
        {getText("Save")}
      </Button>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/controls_component/create_template_control_components.js